import axiosInstance from '../../api/axios.js';

/**
 * GET `/api/risk-control-mappings/rcm` — one page. Forwards search, filters, sort, pagination like `fetchRisksTablePage`.
 * @param {import('../../queries/rcm/keys.ts').RcmTableParams} listParams
 * @returns {Promise<{ items: unknown[], total: number, totalPages: number, page: number }>}
 */
export async function fetchRcmTablePage(listParams) {
  const {
    page,
    pageSize,
    search,
    processId,
    controlId,
    frequency,
    controlType,
    significance,
    riskCategory,
    sortKey,
    sortDir,
    source,
    auditYearId,
  } = listParams;

  const params = {
    page,
    page_size: pageSize,
    ...(search?.trim() ? { search: search.trim() } : {}),
    ...(sortKey ? { sort_by: sortKey, sort_order: sortDir } : {}),
    ...(processId && processId !== 'all' ? { process_id: processId } : {}),
    ...(controlId && controlId !== 'all' ? { control_id: controlId } : {}),
    ...(frequency && frequency !== 'all' ? { frequency } : {}),
    ...(controlType && controlType !== 'all' ? { control_type: controlType } : {}),
    ...(significance && significance !== 'all' ? { significance: significance } : {}),
    ...(riskCategory && riskCategory !== 'all' ? { risk_category: riskCategory } : {}),
    ...(source && source !== 'all' ? { source } : {}),
    ...(auditYearId ? { audit_year_id: auditYearId } : {}),
  };

  const userHash = typeof window !== 'undefined' ? window.localStorage.getItem('userHash') : null;
  const headers = { Authorization: userHash || '' };
  const { data } = await axiosInstance.get('/api/risk-control-mappings/rcm', {
    params,
    headers,
  });
  const items = data?.items ?? [];
  const pagination = data?.pagination;
  const total = Number(pagination?.total_items ?? 0);
  const pagesFromApi = Number(pagination?.total_pages ?? 0);
  const totalPages = total === 0 ? 1 : Math.max(1, pagesFromApi);
  return { items, total, totalPages, page };
}

/**
 * GET `/api/risk-control-mappings/all` — combined Process + ITGC rows (paginated).
 * @param {import('../../queries/rcm/keys.ts').RcmAllTableParams} listParams
 */
export async function fetchRcmAllTablePage(listParams) {
  const {
    page,
    pageSize,
    search,
    classificationFilter,
    soxCycleId,
    domainCode,
    systemId,
    riskCategory,
    auditYearId,
  } = listParams;

  const params = {
    page,
    page_size: pageSize,
    ...(search?.trim() ? { search: search.trim() } : {}),
    ...(classificationFilter && classificationFilter !== 'all'
      ? { classification_filter: classificationFilter }
      : {}),
    ...(soxCycleId && soxCycleId !== 'all' ? { sox_cycle_id: soxCycleId } : {}),
    ...(domainCode && domainCode !== 'all' ? { domain_code: domainCode } : {}),
    ...(systemId && systemId !== 'all' ? { system_id: systemId } : {}),
    ...(riskCategory && riskCategory !== 'all' ? { risk_category: riskCategory } : {}),
    ...(auditYearId ? { audit_year_id: auditYearId } : {}),
  };

  const userHash = typeof window !== 'undefined' ? window.localStorage.getItem('userHash') : null;
  const headers = { Authorization: userHash || '' };
  const { data } = await axiosInstance.get('/api/risk-control-mappings/all', {
    params,
    headers,
  });
  const items = data?.items ?? [];
  const pagination = data?.pagination;
  const total = Number(pagination?.total_items ?? 0);
  const pagesFromApi = Number(pagination?.total_pages ?? 0);
  const totalPages = total === 0 ? 1 : Math.max(1, pagesFromApi);
  return { items, total, totalPages, page };
}
